import { render, staticRenderFns } from "./TransportZones.vue?vue&type=template&id=9c2b83d4&"
import script from "./TransportZones.vue?vue&type=script&lang=js&"
export * from "./TransportZones.vue?vue&type=script&lang=js&"
import style0 from "./TransportZones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports